import { configureStore } from '@reduxjs/toolkit';
import authSlice from 'features/auth/authSlice';
import { cmsSlice } from './cms/cmsSlice';
import { customizationSlice } from './customization/customizationSlice';
import { paginationSlice } from './pagination/paginationSlice';
import { themeSlice } from "./theme/themeSlice"

export const store = configureStore({
  reducer: {
    auth: authSlice,
    [themeSlice.name]: themeSlice.reducer,
    [cmsSlice.name]: cmsSlice.reducer,
    [customizationSlice.name]: customizationSlice.reducer,
    [paginationSlice.name]: paginationSlice.reducer
  }
});

// https://www.youtube.com/watch?v=93CR_yURoII

// https://redux.js.org/introduction/why-rtk-is-redux-today
